@if (!!value) {
  <div
    class="field"
    >
    <label class="upper">{{ displayName }}</label>
    <div class="is-readonly">{{ selectedValue }}</div>
  </div>
}
